<button
  #trigger
  type="button"
  class="cd-trigger"
  [class.variant-form]="variant === 'form'"
  [class.open]="isOpen"
  [class.no-focus]="!showFocus"
  [class.attached-down]="isOpen && !openedUp"
  [class.attached-up]="isOpen && openedUp"
  [class.invalid]="invalid"
  [attr.aria-invalid]="invalid"
  [style.--cd-border]="invalid ? '#dc3545' : borderColor"
  [style.--cd-text]="textColor"
  [style.--cd-active]="activeBorder"
  [disabled]="disabled"
  [attr.id]="inputId || null"
  aria-haspopup="listbox"
  [attr.aria-expanded]="isOpen"
  (click)="toggle()"
  (keydown)="onTriggerKeydown($event)"
>
  <span class="cd-text" [class.placeholder]="!selectedLabel">
    {{ selectedLabel || placeholder }}
  </span>
  <svg class="cd-arrow" [class.rotated]="isOpen" width="12" height="8" viewBox="0 0 12 8" fill="none">
    <path d="M1 1L6 6L11 1" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>

<!-- Panel is teleported to <body> by the CDK overlay -->
<ng-template #panel>
  <div
    class="cd-panel"
    [class.variant-form]="variant === 'form'"
    [class.opens-up]="openedUp"
    [style.--cd-active]="activeBorder"
    [style.--cd-text]="textColor"
    [style.max-height.px]="maxPanelHeight"
    role="listbox"
  >
    <div
      *ngFor="let option of options; let i = index"
      class="cd-item"
      [class.selected]="option.value === value"
      [class.active]="i === activeIndex"
      role="option"
      [attr.aria-selected]="option.value === value"
      (mouseenter)="activeIndex = i"
      (click)="select(option)"
    >
      {{ option.label }}
    </div>
  </div>
</ng-template>